const normalizeEnv = (value) => {
  if (!value) {
    return 'production';
  }
  const normalized = value.toString().trim().toLowerCase();
  if (['development', 'dev'].includes(normalized)) {
    return 'development';
  }
  return 'production';
};

const APP_ENV = normalizeEnv(process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENV || process.env.NODE_ENV);

const API_URLS = {
  development: process.env.REACT_APP_API_URL_DEV || 'http://localhost:5000',
  production:
    process.env.REACT_APP_API_URL_PROD ||
    process.env.REACT_APP_API_URL ||
    'https://restauracjatortuga.pl'
};

export const API_BASE_URL = API_URLS[APP_ENV] || API_URLS.production;

export const FEATURE_FLAGS = {
  menu: true,
  events: true,
  reservations: false,
  whatsapp: false,
  admin: true,
  stats: true
};

export const isFeatureEnabled = (featureKey) => {
  return FEATURE_FLAGS[featureKey] === true;
};

export const getAppEnvironment = () => APP_ENV;
